import type { EventRehearsalSummaryDTO } from "../../domain/contracts";

function formatMoney(value: number) {
  return `${value.toLocaleString()} ກີບ`;
}

type EventRehearsalSummaryProps = {
  summary: EventRehearsalSummaryDTO | undefined;
  isLoading?: boolean;
  show?: boolean;
};

export function EventRehearsalSummary({
  summary,
  isLoading,
  show = true,
}: EventRehearsalSummaryProps) {
  if (!show) return null;
  if (isLoading) {
    return (
      <div className="border-b bg-muted/20 px-5 py-3 text-muted-foreground text-sm">
        ກຳລັງໂຫຼດສະຫຼຸບວັນຊ້ອມ...
      </div>
    );
  }
  if (!summary || summary.totalRehearsalDays === 0) return null;

  return (
    <div className="border-b bg-muted/20 px-5 py-3">
      <div className="flex flex-wrap items-baseline gap-x-6 gap-y-1 text-sm">
        <span>
          <span className="text-muted-foreground">ວັນຊ້ອມລວມ:</span>{" "}
          <span className="font-semibold">{summary.totalRehearsalDays}</span>
        </span>
        <span>
          <span className="text-muted-foreground">ຄາດຄ່າຈ້າງຊ້ອມ:</span>{" "}
          <span className="font-semibold">
            {formatMoney(summary.totalRehearsalAmount)}
          </span>
        </span>
        <span className="text-muted-foreground text-xs">
          {summary.byPerformer.length} ນັກສະແດງ
        </span>
      </div>
    </div>
  );
}
